<div class="dialogForm-overlay" [ngClass]="{'dialogForm-open':shown, 'wide':wideMode}">
  <div class="dialogForm-wrapper" [class.has-top-color]="topColor" [style.border-top-color]="topColor || null">
    <!-- Content stays attached while closed (hidden by the overlay): editors such as TinyMCE bind
         to a live iframe document and break when their element is detached and re-attached. -->
    <div class="dialogForm-body">
      <ng-content select="[body]"></ng-content>
    </div>
    <div class="dialogForm-footer">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>
